import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { ParticipantNote } from '@seen/core/models/participantNote'
import { isOfType } from '@seen/core/utils'
import { useMemo } from 'react'
import { useSearch } from '#src/hooks/useSearch.ts'

interface UseParticipantNoteDraftsResult {
  data: ParticipantNote[] | undefined
}

export function useParticipantNoteDrafts(
  practitioner: Reference<Practitioner>
): UseParticipantNoteDraftsResult {
  const { data } = useSearch(ParticipantNote, {
    ...ParticipantNote.queryAll(),
    author: practitioner,
    'attester:missing': true,
  })
  const filteredNotes = useMemo(
    () => data?.filter((note) => isOfType(note.subject, 'Patient')),
    [data]
  )
  return {
    data: filteredNotes,
  }
}
